"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var currency_js_1 = __importDefault(require("currency.js"));
var react_1 = __importStar(require("react"));
var react_query_1 = require("react-query");
var react_slick_1 = __importDefault(require("react-slick"));
var modal_1 = __importDefault(require("../../plugins/modal"));
var format_bundle_variant_title_1 = __importDefault(require("../../utils/format-bundle-variant-title"));
var utils_1 = require("../account-v3/utils");
var auto_addon_qty_1 = require("../bundler/auto-addon-qty");
var fetch_products_1 = __importDefault(require("../bundler/fetch-products"));
var group_variants_for_cart_add_1 = __importDefault(require("../bundler/group-variants-for-cart-add"));
var is_variant_available_1 = __importDefault(require("../bundler/is-variant-available"));
var update_variants_with_future_quantities_1 = __importDefault(require("../bundler/update-variants-with-future-quantities"));
var app_1 = __importStar(require("../feature-tabs/app"));
// we want to give the freebie on the first shipment only
var SHOULD_SUBSCRIBE_TO_ADDONS = false;
var DIAPER_SIZES = ['N', '1', '2', '3', '4', '5', '6'];
/**
 * @returns total bundle price in dollars
 */
var calculateBundlePrice = function (mainVariant, activeDiscountAddons) {
    // TODO: consider extracting some of this calculation logic from the main bundler and sharing it between here and there
    var e_1, _a;
    var addonsTotalPriceCurrency = (0, currency_js_1.default)(0);
    try {
        for (var activeDiscountAddons_1 = __values(activeDiscountAddons), activeDiscountAddons_1_1 = activeDiscountAddons_1.next(); !activeDiscountAddons_1_1.done; activeDiscountAddons_1_1 = activeDiscountAddons_1.next()) {
            var addon = activeDiscountAddons_1_1.value;
            var addonPrice = (0, currency_js_1.default)(Number(addon.variant.price)).multiply(addon.quantity);
            addonsTotalPriceCurrency = addonsTotalPriceCurrency.add(addonPrice);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (activeDiscountAddons_1_1 && !activeDiscountAddons_1_1.done && (_a = activeDiscountAddons_1.return)) _a.call(activeDiscountAddons_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var mainVariantPriceCurrency = (0, currency_js_1.default)(mainVariant.price_cents, { fromCents: true });
    return mainVariantPriceCurrency.add(addonsTotalPriceCurrency).value;
};
var onSubmit = function (activePatternConfigs, mainVariant, activeDiscountAddons, activeAddons, autoAddons) {
    var e_2, _a, e_3, _b, e_4, _c;
    var _d;
    var expandedAddons = [];
    try {
        for (var activeAddons_1 = __values(activeAddons), activeAddons_1_1 = activeAddons_1.next(); !activeAddons_1_1.done; activeAddons_1_1 = activeAddons_1.next()) {
            var addon = activeAddons_1_1.value;
            for (var i = 0; i < addon.quantity; i++) {
                expandedAddons.push({ variant: addon.variant });
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (activeAddons_1_1 && !activeAddons_1_1.done && (_a = activeAddons_1.return)) _a.call(activeAddons_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    var expandedDiscountAddons = [];
    try {
        for (var activeDiscountAddons_2 = __values(activeDiscountAddons), activeDiscountAddons_2_1 = activeDiscountAddons_2.next(); !activeDiscountAddons_2_1.done; activeDiscountAddons_2_1 = activeDiscountAddons_2.next()) {
            var addon = activeDiscountAddons_2_1.value;
            for (var i = 0; i < addon.quantity; i++) {
                expandedDiscountAddons.push({ variant: addon.variant });
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (activeDiscountAddons_2_1 && !activeDiscountAddons_2_1.done && (_b = activeDiscountAddons_2.return)) _b.call(activeDiscountAddons_2);
        }
        finally { if (e_3) throw e_3.error; }
    }
    var addonOrigTotals = expandedAddons.map(function (addOn) { return Number(addOn.variant.compare_at_price); }).reduce(function (acc, prc) { return acc + prc; }, 0);
    var discountAddonOrigTotals = expandedDiscountAddons.map(function (addOn) { return Number(addOn.variant.compare_at_price); }).reduce(function (acc, prc) { return acc + prc; }, 0);
    var subscriptionProperties = {
        charge_interval_frequency: '5',
        original_bundle_value: addonOrigTotals + discountAddonOrigTotals + mainVariant.price_cents / 100,
        compare_at_price: Number(mainVariant.compare_at_price_cents || mainVariant.price_cents),
        shipping_interval_frequency: '5',
        shipping_interval_unit_type: 'week',
        subscription_id: "".concat(mainVariant.subscription_id), // this is a string in the diaper bundler, so we mimic that here
    };
    var bundleId = new Date().getTime().toString();
    var childProperties = __assign({ parent_bundle_id: bundleId }, subscriptionProperties);
    // build activePatternVariants with `quantity` duplicate variants per pattern
    var activePatternVariants = [];
    try {
        for (var activePatternConfigs_1 = __values(activePatternConfigs), activePatternConfigs_1_1 = activePatternConfigs_1.next(); !activePatternConfigs_1_1.done; activePatternConfigs_1_1 = activePatternConfigs_1.next()) {
            var pattern = activePatternConfigs_1_1.value;
            for (var i = 0; i < pattern.quantity; i++) {
                activePatternVariants.push(pattern.variant);
            }
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (activePatternConfigs_1_1 && !activePatternConfigs_1_1.done && (_c = activePatternConfigs_1.return)) _c.call(activePatternConfigs_1);
        }
        finally { if (e_4) throw e_4.error; }
    }
    // allocate autoAddOns
    var autoAddOnVariants = (function () {
        if (!autoAddons) {
            return [];
        }
        return autoAddons.reduce(function (arr, _a) {
            var _b = __read(_a, 2), _ = _b[0], variant = _b[1];
            for (var j = 0; j < (0, auto_addon_qty_1.computeAutoAddonQty)(variant, mainVariant); j++) {
                arr.push(variant);
            }
            return arr;
        }, []);
    })();
    var bundle = __spreadArray(__spreadArray(__spreadArray(__spreadArray([
        [mainVariant.variant_id, { properties: __assign({ bundle_id: bundleId, bundle_source: 'prebuiltDiaperBundler' }, subscriptionProperties) }]
    ], __read((0, group_variants_for_cart_add_1.default)(activePatternVariants, childProperties).map(function (item) { return item.createItemParams; })), false), __read((0, group_variants_for_cart_add_1.default)(expandedAddons.map(function (addOn) { return addOn.variant; }), SHOULD_SUBSCRIBE_TO_ADDONS ? childProperties : { parent_bundle_id: bundleId }).map(function (item) { return item.createItemParams; })), false), __read((0, group_variants_for_cart_add_1.default)(expandedDiscountAddons.map(function (addOn) { return addOn.variant; }), childProperties).map(function (item) { return item.createItemParams; })), false), __read((0, group_variants_for_cart_add_1.default)(autoAddOnVariants, childProperties).map(function (item) { return item.createItemParams; })), false);
    // we don't want to run this Optimize test on the prebuilt bundler
    var REDIRECT_TO_CHECKOUT = false;
    (_d = window.dataLayer) === null || _d === void 0 ? void 0 : _d.push({ event: 'prebuiltBundle__addToCart', bundleVariantId: mainVariant.variant_id, bundleVariantName: mainVariant.variant_name });
    return window.cartApp.add(bundle, { redirectToCheckout: REDIRECT_TO_CHECKOUT });
};
var Addon = function (_a) {
    var addon = _a.addon;
    return (react_1.default.createElement("div", { style: { marginBottom: '16px', paddingLeft: '0.625em' }, key: "".concat(addon.variant.title, "-").concat(addon.variant.option2) },
        react_1.default.createElement("div", { style: { width: '48px', display: 'table-cell' } },
            react_1.default.createElement("div", { className: 'pattern-circle-container', style: { width: '48px', height: '48px', padding: '4px', border: '1px solid #737373', borderRadius: '2px', position: 'relative' } },
                react_1.default.createElement("img", { src: addon.product.images[0].src, alt: addon.variant.option2 }),
                react_1.default.createElement("div", { className: 'quantity-badge' }, addon.quantity))),
        react_1.default.createElement("div", { style: { display: 'table-cell', verticalAlign: 'top', paddingLeft: '20px' } },
            react_1.default.createElement("div", { style: { fontSize: '12px', fontWeight: 500, color: '#252729' } },
                react_1.default.createElement("span", null, (0, format_bundle_variant_title_1.default)(addon.product.title))),
            addon.variant.title.toLowerCase() !== 'default title' && react_1.default.createElement("div", { style: { fontSize: '12px', color: '#737373' } }, addon.variant.title))));
};
var PrebuiltBundler = function (props) {
    var _a, _b, _c, _d;
    var diaperVariantConfigs = props.variantConfigs.filter(function (config) { return config.diapers_or_training_pants === 'diapers'; });
    if (diaperVariantConfigs.length !== 1)
        throw new Error('CMS Error: Exactly one Diapers Variant Config is required');
    var trainingPantVariantConfigs = props.variantConfigs.filter(function (config) { return config.diapers_or_training_pants === 'training_pants'; });
    if (trainingPantVariantConfigs.length !== 0)
        throw new Error('CMS Error: Exactly zero Training Pants Variant Configs are required');
    var minPatternInventory = parseInt(props.minPatternInventory, 10);
    if (isNaN(minPatternInventory))
        throw new Error('CMS Error: minPatternInventory not provided');
    var minDiscountAddonInventory = parseInt(props.minDiscountAddonInventory, 10);
    if (isNaN(minDiscountAddonInventory))
        throw new Error('CMS Error: invalid minDiscountAddonInventory');
    var minAddonInventory = parseInt(props.minAddonInventory, 10);
    if (isNaN(minAddonInventory))
        throw new Error('CMS Error: invalid minAddonInventory');
    var bazaarvoiceRatingSummaryProductId = parseInt(props.bazaarvoiceRatingSummaryProductId, 10);
    if (isNaN(bazaarvoiceRatingSummaryProductId))
        throw new Error('CMS Error: bazaarvoiceRatingSummaryProductId not provided');
    var featureTabs = props.featureTabs;
    if (!(0, app_1.isTabs)(featureTabs))
        throw new Error('CMS Error: Invalid feature tab');
    var sizeConfigs = (0, react_1.useMemo)(function () {
        return props.variantConfigs.map(function (item) {
            var e_5, _a, e_6, _b;
            if (!item.boy_pattern_names || !item.girl_pattern_names)
                throw new Error('CMS Error: Not all required Variant Config fields are filled out');
            var discountAddonConfigs = [];
            if (item.discount_addon_variant_ids) {
                // to build addon configs, first split the text into lines
                var discountAddonTextLines = item.discount_addon_variant_ids.split('\n');
                try {
                    // then split each line into variant id and quantity
                    for (var discountAddonTextLines_1 = __values(discountAddonTextLines), discountAddonTextLines_1_1 = discountAddonTextLines_1.next(); !discountAddonTextLines_1_1.done; discountAddonTextLines_1_1 = discountAddonTextLines_1.next()) {
                        var line = discountAddonTextLines_1_1.value;
                        var _c = __read(line.split(':'), 2), variantId = _c[0], quantity = _c[1];
                        discountAddonConfigs.push({ variantId: Number(variantId), quantity: Number(quantity) });
                    }
                }
                catch (e_5_1) { e_5 = { error: e_5_1 }; }
                finally {
                    try {
                        if (discountAddonTextLines_1_1 && !discountAddonTextLines_1_1.done && (_a = discountAddonTextLines_1.return)) _a.call(discountAddonTextLines_1);
                    }
                    finally { if (e_5) throw e_5.error; }
                }
            }
            var addonConfigs = [];
            if (item.addon_variant_ids) {
                var addonTextLines = item.addon_variant_ids.split('\n');
                try {
                    for (var addonTextLines_1 = __values(addonTextLines), addonTextLines_1_1 = addonTextLines_1.next(); !addonTextLines_1_1.done; addonTextLines_1_1 = addonTextLines_1.next()) {
                        var line = addonTextLines_1_1.value;
                        var _d = __read(line.split(':'), 2), variantId = _d[0], quantity = _d[1];
                        addonConfigs.push({ variantId: Number(variantId), quantity: Number(quantity) });
                    }
                }
                catch (e_6_1) { e_6 = { error: e_6_1 }; }
                finally {
                    try {
                        if (addonTextLines_1_1 && !addonTextLines_1_1.done && (_b = addonTextLines_1.return)) _b.call(addonTextLines_1);
                    }
                    finally { if (e_6) throw e_6.error; }
                }
            }
            return {
                addonConfigs: addonConfigs,
                discountAddonConfigs: discountAddonConfigs,
                boyPatternNames: item.boy_pattern_names.split('\n'),
                girlPatternNames: item.girl_pattern_names.split('\n'),
                diapersOrTrainingPants: item.diapers_or_training_pants,
            };
        });
    }, [props.variantConfigs]);
    var FUTURE_QUANTITIES_DAYS_AHEAD = 3;
    // fetch products and future quantities
    var productsQuery = (0, react_query_1.useQuery)('prebuiltBundlerProducts', function () { return __awaiter(void 0, void 0, void 0, function () {
        var products;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, fetch_products_1.default)()];
                case 1:
                    products = _a.sent();
                    if (!(products.possibleChoices && products.discountAddOns && products.addOns)) return [3 /*break*/, 3];
                    return [4 /*yield*/, (0, update_variants_with_future_quantities_1.default)({
                            daysAhead: FUTURE_QUANTITIES_DAYS_AHEAD,
                            possibleChoices: products.possibleChoices,
                            addOns: products.addOns,
                            discountAddOns: products.discountAddOns,
                        })];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/, products];
            }
        });
    }); });
    var mainDiaperBundleWithWipesSizeToVariantIdMap = (0, react_1.useMemo)(function () {
        var e_7, _a;
        var result = {};
        try {
            for (var _b = __values(props.mainDiaperBundleProduct.variants), _c = _b.next(); !_c.done; _c = _b.next()) {
                var variant = _c.value;
                if (!variant.option2.includes('wipes'))
                    continue; // find only wipesful bundles
                var mainVariant_1 = {
                    variant_id: variant.id,
                    compare_at_price_cents: Number(variant.compare_at_price),
                    subscription_id: Number(props.subscriptionId),
                    price_cents: Number(variant.price),
                    option2: variant.option2,
                    variant_name: variant.name,
                };
                if (DIAPER_SIZES.includes(variant.option1))
                    result[variant.option1] = mainVariant_1;
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_7) throw e_7.error; }
        }
        return result;
    }, [props.mainDiaperBundleProduct.variants, props.subscriptionId]);
    var genders = ['Boys', 'Girls', 'Gender Neutral'];
    var _e = __read((0, react_1.useState)('N'), 2), selectedSizeKey = _e[0], setSelectedSizeKey = _e[1];
    var _f = __read((0, react_1.useState)('Boys'), 2), selectedGender = _f[0], setSelectedGender = _f[1];
    // we hardcode this because we only support diaper bundles for now
    var SELECTED_DIAPERS_OR_TRAINING_PANTS = 'diapers';
    var DIAPER_BUNDLE_NUM_PACKS = 7;
    var TRAINING_PANTS_NUM_PACKS = 6;
    var validNumPacks = (0, react_1.useMemo)(function () {
        if (SELECTED_DIAPERS_OR_TRAINING_PANTS === 'diapers')
            return DIAPER_BUNDLE_NUM_PACKS;
        return TRAINING_PANTS_NUM_PACKS;
    }, [SELECTED_DIAPERS_OR_TRAINING_PANTS, DIAPER_BUNDLE_NUM_PACKS, TRAINING_PANTS_NUM_PACKS]);
    var sizeConfig = sizeConfigs.find(function (config) { return config.diapersOrTrainingPants === SELECTED_DIAPERS_OR_TRAINING_PANTS; });
    if (!sizeConfig)
        throw new Error("CMS Error: No ".concat(SELECTED_DIAPERS_OR_TRAINING_PANTS, " Variant Config"));
    // patterns for this size, based on gender, and available inventory
    // undefined means we were unable to build a bundle of patterns due to low inventory
    var activePatternConfigs = (0, react_1.useMemo)(function () {
        var e_8, _a;
        var _b;
        if (!selectedSizeKey)
            return [];
        if (!selectedGender)
            return [];
        if (!((_b = productsQuery.data) === null || _b === void 0 ? void 0 : _b.possibleChoices))
            return [];
        var patternNames;
        if (selectedGender === 'Boys' || selectedGender === 'Gender Neutral')
            patternNames = sizeConfig.boyPatternNames;
        else
            patternNames = sizeConfig.girlPatternNames;
        // add one of each variant if it has inventory until we've gone through all of our patternVariants or we've reached the proper number of packs
        var patternVariants = [];
        var prevNumChosenPatterns = 0;
        var newNumChosenPatterns = 0;
        do {
            var _loop_1 = function (patternName) {
                var foundChoice = productsQuery.data.possibleChoices.find(function (choice) { return selectedSizeKey === choice.option1 && patternName === choice.option2; });
                // We might not have this pattern for this size, or we might not have this pattern at all, or the name of the pattern in the CMS might be wrong.
                if (!foundChoice)
                    return "continue";
                // Don't add if out of stock or low inventory.
                // Notably, we do not check the edge case where selecting more than one of a particular pattern will put us over the remaining inventory available,
                // because in a dynamic system where inventory is constantly changing, it's probably not accurate enough to be worth the additional code complexity.
                if (!(0, is_variant_available_1.default)(foundChoice) || (0, utils_1.isVariantLowStock)(foundChoice)) {
                    return "continue";
                }
                // Either push our newly selected pattern or increment the pattern's quantity if we've already selected it.
                var alreadySelectedPattern = patternVariants.find(function (variant) { return foundChoice.id === variant.variant.id; });
                if (alreadySelectedPattern) {
                    alreadySelectedPattern.quantity += 1;
                }
                else {
                    patternVariants.push({ variant: foundChoice, quantity: 1 });
                }
                // Inform the do-while loop whether or not we're making any progress anymore in getting enough patterns to make a bundle.
                var numChosenPatterns = patternVariants.reduce(function (total, pattern) { return total + pattern.quantity; }, 0);
                prevNumChosenPatterns = newNumChosenPatterns;
                newNumChosenPatterns = numChosenPatterns;
                // Do we have enough selected patterns to make a bundle? If so, exit both loops right away.
                if (numChosenPatterns === validNumPacks)
                    return { value: patternVariants };
            };
            try {
                for (var patternNames_1 = (e_8 = void 0, __values(patternNames)), patternNames_1_1 = patternNames_1.next(); !patternNames_1_1.done; patternNames_1_1 = patternNames_1.next()) {
                    var patternName = patternNames_1_1.value;
                    var state_1 = _loop_1(patternName);
                    if (typeof state_1 === "object")
                        return state_1.value;
                }
            }
            catch (e_8_1) { e_8 = { error: e_8_1 }; }
            finally {
                try {
                    if (patternNames_1_1 && !patternNames_1_1.done && (_a = patternNames_1.return)) _a.call(patternNames_1);
                }
                finally { if (e_8) throw e_8.error; }
            }
        } while (newNumChosenPatterns > prevNumChosenPatterns);
        return patternVariants;
    }, [(_a = productsQuery.data) === null || _a === void 0 ? void 0 : _a.possibleChoices, selectedGender, selectedSizeKey, sizeConfig.boyPatternNames, sizeConfig.girlPatternNames, validNumPacks]);
    // the pre-selected paid add-ons
    var activeDiscountAddons = (0, react_1.useMemo)(function () {
        var e_9, _a;
        var _b;
        if (!((_b = productsQuery.data) === null || _b === void 0 ? void 0 : _b.discountAddOns))
            return [];
        var addonVariants = [];
        var _loop_2 = function (config) {
            var foundChoice = productsQuery.data.discountAddOns.find(function (choice) { return config.variantId === choice[1].id; });
            if (!foundChoice)
                throw new Error('CMS Error: Invalid Variant Config Discount Addons Settings');
            if (!(0, is_variant_available_1.default)(foundChoice[1]) || (0, utils_1.isVariantLowStock)(foundChoice[1])) {
                return "continue";
            }
            addonVariants.push({
                product: foundChoice[0],
                variant: foundChoice[1],
                quantity: config.quantity,
            });
        };
        try {
            for (var _c = __values(sizeConfig.discountAddonConfigs), _d = _c.next(); !_d.done; _d = _c.next()) {
                var config = _d.value;
                _loop_2(config);
            }
        }
        catch (e_9_1) { e_9 = { error: e_9_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_9) throw e_9.error; }
        }
        return addonVariants;
    }, [(_b = productsQuery.data) === null || _b === void 0 ? void 0 : _b.discountAddOns, sizeConfig.discountAddonConfigs]);
    // the pre-selected freebies
    var activeAddons = (0, react_1.useMemo)(function () {
        var e_10, _a;
        var _b;
        if (!((_b = productsQuery.data) === null || _b === void 0 ? void 0 : _b.addOns))
            return [];
        var addonVariants = [];
        var _loop_3 = function (config) {
            var foundChoice = productsQuery.data.addOns.find(function (choice) { return config.variantId === choice[1].id; });
            if (!foundChoice)
                throw new Error('CMS Error: Invalid Variant Config Addons Settings');
            if (!(0, is_variant_available_1.default)(foundChoice[1]) || (0, utils_1.isVariantLowStock)(foundChoice[1])) {
                return "continue";
            }
            addonVariants.push({
                product: foundChoice[0],
                variant: foundChoice[1],
                quantity: config.quantity,
            });
        };
        try {
            for (var _c = __values(sizeConfig.addonConfigs), _d = _c.next(); !_d.done; _d = _c.next()) {
                var config = _d.value;
                _loop_3(config);
            }
        }
        catch (e_10_1) { e_10 = { error: e_10_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_10) throw e_10.error; }
        }
        return addonVariants;
    }, [(_c = productsQuery.data) === null || _c === void 0 ? void 0 : _c.addOns, sizeConfig.addonConfigs]);
    var autoAddons = (0, react_1.useMemo)(function () {
        var _a, _b;
        if (!((_a = productsQuery.data) === null || _a === void 0 ? void 0 : _a.autoAddOns))
            return [];
        return (_b = productsQuery.data) === null || _b === void 0 ? void 0 : _b.autoAddOns;
    }, [(_d = productsQuery.data) === null || _d === void 0 ? void 0 : _d.autoAddOns]);
    var addToCartButtonEnabled = (0, react_1.useMemo)(function () {
        // Do we have all of the pre-selected paid addons?
        if (activeDiscountAddons.length !== sizeConfig.discountAddonConfigs.length)
            return false;
        // Do we have all of the pre-selected freebies?
        if (activeAddons.length !== sizeConfig.addonConfigs.length)
            return false;
        // Do we have at least one auto add-on? The diaper bundles with wipes that we're dealing with all have auto addons (the wipes).
        if (autoAddons.length < 1)
            return false;
        // Do we have enough packs to make a bundle?
        var numSelectedPacks = activePatternConfigs.reduce(function (total, config) { return total + config.quantity; }, 0);
        return numSelectedPacks >= validNumPacks;
    }, [validNumPacks, activePatternConfigs, activeDiscountAddons, sizeConfig.discountAddonConfigs.length, autoAddons, activeAddons.length, sizeConfig.addonConfigs.length]);
    var _g = __read((0, react_1.useState)(false), 2), isSizingChartModalOpen = _g[0], setIsSizingChartModalOpen = _g[1];
    var mainVariant = selectedSizeKey && mainDiaperBundleWithWipesSizeToVariantIdMap[selectedSizeKey];
    var totalPrice = (0, react_1.useMemo)(function () {
        return mainVariant && calculateBundlePrice(mainVariant, activeDiscountAddons);
    }, [mainVariant, activeDiscountAddons]);
    return (react_1.default.createElement("div", { className: 'prebuilt-bundler' },
        props.modalSettings.enableModal && (react_1.default.createElement(modal_1.default, { isOpen: isSizingChartModalOpen, handleClose: function () { return setIsSizingChartModalOpen(false); } },
            react_1.default.createElement("div", { className: 'padding-vertical-10 grid-container' },
                react_1.default.createElement("div", { className: 'padding-vertical-3' }, props.modalSettings.modalHeader),
                react_1.default.createElement("div", { className: 'show-for-medium' },
                    react_1.default.createElement("img", { src: props.modalSettings.modalImage, alt: props.modalSettings.linkText })),
                react_1.default.createElement("div", { className: 'hide-for-medium' },
                    react_1.default.createElement("img", { src: props.modalSettings.mobileModalImage, alt: props.modalSettings.linkText }))))),
        react_1.default.createElement("div", { className: 'bg-white padding-bottom-5' },
            react_1.default.createElement("div", { className: 'grid-container medium-padding-top-10' },
                react_1.default.createElement("div", { className: 'grid-x grid-margin-x padding-top-5 medium-padding-horizontal-20' },
                    react_1.default.createElement("div", { className: 'cell small-12 medium-7 padding-bottom-15' },
                        react_1.default.createElement("div", { className: 'grid-container' },
                            react_1.default.createElement("div", { className: 'pdp-carousel pdp-images-carousel', style: { border: 'solid #ededed', borderRadius: '10px' } }, props.productImages && (react_1.default.createElement(react_slick_1.default, { dots: true, dotsClass: 'slick-dots', arrows: false }, props.productImages.map(function (src) {
                                return (react_1.default.createElement("img", { key: src, src: src, className: 'margin-horizontal-auto object-fit-cover width-100 height-100', style: { borderRadius: '10px' }, alt: 'Product image' }));
                            })))))),
                    react_1.default.createElement("div", { className: 'cell small-12 medium-5' },
                        react_1.default.createElement("div", { className: 'small-padding-top-4' },
                            react_1.default.createElement("h3", null, props.productTitle),
                            props.bazaarvoiceEnabled && (react_1.default.createElement("div", { className: 'padding-vertical-3' },
                                react_1.default.createElement("div", { "data-bv-show": 'rating_summary', "data-bv-product-id": bazaarvoiceRatingSummaryProductId }))),
                            react_1.default.createElement("div", { className: 'text-brownish-grey' }, props.productDescription)),
                        react_1.default.createElement("div", { className: 'padding-vertical-2' },
                            react_1.default.createElement("div", { className: 'padding-bottom-2', style: { fontSize: '14px' } },
                                react_1.default.createElement("span", { className: 'font-bold' }, "Size:"),
                                props.modalSettings.enableModal && (react_1.default.createElement("a", { className: 'position-relative float-right text-wisteria text-underline', onClick: function () { return setIsSizingChartModalOpen(true); } }, props.modalSettings.linkText))),
                            react_1.default.createElement("select", { className: 'margin-0', name: 'size', onChange: function (event) { return setSelectedSizeKey(event.target.value); } }, DIAPER_SIZES.map(function (size) { return (react_1.default.createElement("option", { key: size, value: size }, size)); }))),
                        react_1.default.createElement("div", { className: 'padding-vertical-2' },
                            react_1.default.createElement("div", { className: 'padding-bottom-2', style: { fontSize: '14px' } },
                                react_1.default.createElement("span", { className: 'font-bold' }, "Gender:")),
                            react_1.default.createElement("select", { name: 'gender', style: { marginBottom: '0.25rem', paddingBottom: 0 }, onChange: function (event) { return setSelectedGender(event.target.value); } }, genders.map(function (gender) { return (react_1.default.createElement("option", { key: gender, value: gender }, gender)); })),
                            react_1.default.createElement("div", { style: { fontSize: '12px' } }, props.belowGenderInputText)),
                        (activeDiscountAddons === null || activeDiscountAddons === void 0 ? void 0 : activeDiscountAddons.length) > 0 && (react_1.default.createElement("div", { className: 'patterns-display padding-top-2' },
                            react_1.default.createElement("div", { className: 'padding-bottom-3' }, "Add-ons"),
                            activeDiscountAddons.map(function (addon, index) {
                                return react_1.default.createElement(Addon, { key: index, addon: addon });
                            }))),
                        (activeAddons === null || activeAddons === void 0 ? void 0 : activeAddons.length) > 0 && (react_1.default.createElement("div", { className: 'patterns-display padding-top-2' },
                            react_1.default.createElement("div", { className: 'padding-bottom-3' },
                                react_1.default.createElement("div", null, "Freebies"),
                                !SHOULD_SUBSCRIBE_TO_ADDONS && react_1.default.createElement("div", { style: { fontSize: '12px' } }, "You\u2019ll get these item(s) for free in your first shipment!")),
                            activeAddons.map(function (addon, index) {
                                return react_1.default.createElement(Addon, { key: index, addon: addon });
                            }))),
                        react_1.default.createElement("div", { className: 'width-100 text-center padding-top-2', style: { fontSize: '15px' } },
                            react_1.default.createElement("button", { className: (0, classnames_1.default)(!addToCartButtonEnabled ? 'bg-alto' : 'bg-wisteria', 'button width-100 text-center text-white padding-5'), disabled: !addToCartButtonEnabled, style: { pointerEvents: 'auto', width: '100%', height: '100%' }, onClick: function () { return mainVariant && onSubmit(activePatternConfigs, mainVariant, activeDiscountAddons, activeAddons, autoAddons); } }, addToCartButtonEnabled ? "Add to Cart".concat(totalPrice !== undefined ? ' - ' + totalPrice : '') : 'Out of Stock')),
                        featureTabs && (react_1.default.createElement("div", { className: 'padding-top-5' },
                            react_1.default.createElement(app_1.default, { tabs: featureTabs }))),
                        props.awards && (react_1.default.createElement("div", { className: 'padding-top-5 padding-bottom-10' },
                            react_1.default.createElement("div", { className: 'padding-top-10', style: { fontSize: '16px', border: '1px solid #e6e6e6', borderStyle: 'solid none none none' } }, "Awards"),
                            react_1.default.createElement("div", { className: 'padding-vertical-3', style: { display: 'flex' } }, props.awards.map(function (award) {
                                return (react_1.default.createElement("div", { key: award.img_src, className: 'padding-right-3' }, award.add_link ? (react_1.default.createElement("a", { href: award.link },
                                    react_1.default.createElement("img", { src: award.img_src, style: { maxHeight: '125px' }, alt: 'Award' }))) : (react_1.default.createElement("img", { src: award.img_src, style: { maxHeight: '125px' }, alt: 'Award' }))));
                            }))))))))));
};
exports.default = PrebuiltBundler;
